import { ProductType } from "@obg/core.config";
import { EnvironmentType } from "@obg/ngx.global";
import { head } from "lodash-es";

import { CoreState } from "../state";

import { AppContext, Device } from "./app-context.model";

/**
 * @deprecated - [fabric-deprecated] - Use StartupContextService from svc-config instead.
 * */
export namespace AppContextSelector {
	/**
	 * @deprecated [fabric-deprecated] - Use StartupContextService instead
	 */
	export const getState = (state: CoreState): AppContext => state.appContext;

	export const getProductHistory = (state: CoreState): ProductType[] => state.appContext.productHistory;

	export const getPreviousProduct = (state: CoreState): ProductType | undefined =>
		head(state.appContext.productHistory);

	/**
	 * @deprecated [fabric-deprecated] - Use StartupContextService: ConfigServiceValue.DeviceExperience or ConfigServiceValue.DeviceType instead
	 */
	export const getDevice = (state: CoreState): Device => state.appContext.device!;

	/**
	 * @deprecated [fabric-deprecated] - Use StartupContextService: ConfigServiceValue.CountryCode instead
	 */
	export const getCountryCode = (state: CoreState): string | undefined => state.appContext.countryCode;

	export const getProduct = (state: CoreState): ProductType | undefined => state.appContext.product;

	/**
	 * @deprecated [fabric-deprecated] - Use StartupContextService: ConfigServiceValue.Environment instead
	 */
	export const getEnvironment = (state: CoreState): EnvironmentType => state.appContext.environment;

	/**
	 * @deprecated [fabric-deprecated] - Use StartupContextService: ConfigServiceValue.IsInternal instead
	 */
	export const isDebug = (state: CoreState): boolean => state.appContext.isDebug;
}
